import { Component } from '@angular/core';

@Component({
	selector: 'cass-account-created-page',
	templateUrl: './account-created-page.component.html',
	styleUrls: ['./account-created-page.component.css']
})
export class AccountCreatedPageComponent {
	constructor () {
	}
}
